import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";
import { useLocale } from "@/contexts/LocaleContext";

export const MarketTicker = () => {
  const [indicators, setIndicators] = useState([]);
  const { t } = useLocale();

  useEffect(() => {
    let mounted = true;
    api.get("/indicators").then((r) => mounted && setIndicators(r.data)).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!indicators.length) return null;
  const doubled = [...indicators, ...indicators, ...indicators];

  // Translate indicator name via its code (e.g., ARABICA_NY -> indicator.arabica_ny).
  // Falls back to ind.name if no translation is found.
  const tName = (ind) => {
    if (!ind.code) return ind.name;
    const key = `indicator.${ind.code.toLowerCase()}`;
    const translated = t(key);
    return translated === key ? ind.name : translated;
  };

  return (
    <div className="relative overflow-hidden border-y border-border bg-secondary/40 dark:bg-card">
      <div className="flex items-center">
        <div className="shrink-0 z-10 px-4 py-2 border-r border-border bg-background font-mono-data text-[10px] uppercase tracking-[0.25em] text-accent">
          {t("ticker.label")}
        </div>
        <div className="ticker-marquee flex gap-10 py-2">
          {doubled.map((ind, i) => (
            <span key={`${ind.id}-${i}`} className="flex items-center gap-2 font-mono-data text-xs">
              <span className="text-muted-foreground">{tName(ind)}</span>
              <span className="text-foreground font-medium">
                {ind.value?.toFixed(2)} <span className="text-muted-foreground text-[10px]">{ind.unit}</span>
              </span>
              <span className={`flex items-center gap-0.5 ${(ind.change_pct || 0) >= 0 ? "text-emerald-500" : "text-red-500"}`}>
                {(ind.change_pct || 0) >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                {(ind.change_pct || 0).toFixed(2)}%
              </span>
              <span className="text-border">/</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
